import { useSyncExternalStore } from 'react'

// Skins — same mechanism as Magnify: a token set selected by data-theme on <html>,
// persisted in localStorage. Add a skin by adding a [data-theme="id"] block in theme.css
// and an entry here. No component code changes needed.
export interface Skin { id: string; name: string }
export const SKINS: Skin[] = [
  { id: 'midnight', name: 'Midnight' },
  { id: 'daylight', name: 'Daylight' },
  { id: 'carbon', name: 'Carbon' }
]

const KEY = 'stationbridge.skin'
const DEFAULT = 'midnight'

function load(): string {
  try {
    const s = localStorage.getItem(KEY)
    return SKINS.some((k) => k.id === s) ? (s as string) : DEFAULT
  } catch { return DEFAULT }
}

let current = load()
const listeners = new Set<() => void>()

function apply(id: string): void {
  if (typeof document !== 'undefined') document.documentElement.dataset.theme = id
}
apply(current)

export const getSkin = (): string => current
export function setSkin(id: string): void {
  current = id
  try { localStorage.setItem(KEY, id) } catch { /* ignore */ }
  apply(id)
  for (const l of listeners) l()
}
const subscribe = (cb: () => void): (() => void) => { listeners.add(cb); return () => listeners.delete(cb) }
export const useSkin = (): string => useSyncExternalStore(subscribe, getSkin, getSkin)
